var _defs, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 103 125",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#f05;}.cls-3{fill:url(#linear-gradient-2);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 72.36,
    y1: 16.81,
    x2: -12.94,
    y2: 64.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#e0004b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#df024b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#db0b4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#d5194c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cc2b4d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 4651.45,
    y1: 1409.5,
    x2: 4566.15,
    y2: 1456.78,
    gradientTransform: "translate(4682.09 1517.69) rotate(180)",
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M78.19,4.65V25.16A2.11,2.11,0,0,1,77.08,27L2.27,68.33V44.23a2.38,2.38,0,0,1,1.26-2.07L74.74,2.8A2.29,2.29,0,0,1,78.19,4.65Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M46.84,70.77,6.48,45.49h0s-2-1-2.05-2.29a2.78,2.78,0,0,1,1.05-2.12l-2,1.08a2.78,2.78,0,0,0-1.06,1.11,2,2,0,0,0-.2.87h0v27.1a2.21,2.21,0,0,0,1.06,1.86L23.54,85.77a2.47,2.47,0,0,0,2.49.06L46.73,74.4A2.08,2.08,0,0,0,46.84,70.77Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M24.81,120.35V99.84A2.11,2.11,0,0,1,25.92,98l74.81-41.33v24.1a2.38,2.38,0,0,1-1.26,2.07L28.26,122.2A2.29,2.29,0,0,1,24.81,120.35Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M56.16,54.23,96.52,79.51h0s2,1,2,2.29a2.78,2.78,0,0,1-1,2.12l2-1.08a2.78,2.78,0,0,0,1.06-1.11,2,2,0,0,0,.2-.87h0V53.75a2.21,2.21,0,0,0-1.06-1.86L79.46,39.23A2.47,2.47,0,0,0,77,39.17L56.27,50.6A2.21,2.21,0,0,0,56.16,54.23Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.e60494d833a994194a04faac39c77080.svg";
export { ForwardRef as ReactComponent };